import { createComponent, ElementWithProps } from '@carvana/merch-components';
import cx from 'classnames';
import {
  baseButtonClasses,
  buttonSizeClasses,
  primaryButtonClasses,
  secondaryButtonClasses
} from './Button';

export type AnchorButtonProps = ElementWithProps<
  { size?: 'lg' | 'md' | 'sm' | 'xs' },
  HTMLAnchorElement
>;

export const BaseAnchorButton = createComponent<AnchorButtonProps>(
  'a',
  ({ size = 'md' }) => ({
    className: cx(baseButtonClasses, buttonSizeClasses[size])
  })
);

export const AnchorButton = createComponent<AnchorButtonProps>(
  BaseAnchorButton,
  {
    className: primaryButtonClasses
  }
);

export const SecondaryAnchorButton = createComponent<AnchorButtonProps>(
  BaseAnchorButton,
  {
    className: secondaryButtonClasses
  }
);
